{
  "lastUpdatedAt": "2026-05-22T22:37:48.123Z",
  "lastFetchAttemptAt": "2026-05-22T22:37:48.123Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}